import { Box, Modal, styled, Typography } from '@mui/material';

interface IdCardStyledProps {
  homeEnabled?: boolean;
}

export const ModalStyled = styled(Modal)(({ theme }) => ({
  zIndex: 0,
  overflow: 'auto',
  paddingTop: theme.spacing(10),
  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.primaryLight.main,
  },
}));

export const IdCardFocusedWrapperStyled = styled(Box)({
  overflowX: 'hidden',
  position: 'relative',
});

export const IdCardFocusedStyled = styled(Box)<IdCardStyledProps>(({ theme, homeEnabled }) => ({
  backgroundColor: theme.palette.primaryLight.main,
  padding: theme.spacing(20, 6),
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  [theme.breakpoints.up('md')]: {
    margin: 'auto',
    marginTop: '4rem',
  },
  [theme.breakpoints.up('lg')]: {
    width: homeEnabled ? 670 : 920,
    paddingLeft: homeEnabled ? 0 : 250,
    paddingRight: 0,
  },
}));

export const LoaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.primaryLight.main,
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
}));

export const ActionsWrapperStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const HiddenInLandscapeWrapper = styled(Typography)({
  '@media (orientation: landscape)': {
    display: 'none',
  },
});

export const PdfContentStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  height: '1122px',
  justifyContent: 'center',
  paddingTop: '2rem',
  pointerEvents: 'none',
  position: 'absolute',
  top: '-100%',
  zIndex: '-999',
  width: '794px',

  img: {
    maxWidth: 'calc(100% - 4rem)',
    maxHeight: '531px',
  },
});
